import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'group', label: 'Category' },
  { key: 'metric', label: 'Ratio' },
  { key: 'value', label: 'Value', align: 'right' },
  { key: 'formula', label: 'Formula' },
];

export function RatioAnalysisReport() {
  return (
    <ReportView
      title="Ratio Analysis"
      description="Standard liquidity, solvency and profitability ratios computed from the Chart of Accounts — the balance-sheet ratios as of the end of the selected period, the profitability ratios for the period itself."
      endpoint="/reports/consolidated/ratio-analysis"
      columns={COLUMNS}
      filters={['dateRange']}
      xlsx
    />
  );
}
